'use strict';

var StrategyEditConfirmDirective = function StrategyEditConfirmDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategy-edit-confirm.html'),
    scope: {
      strategy: '=',
      strategySaveConfirm: '&'
    },
    link: function link($scope) {
      $scope.okClicked = function () {
        $scope.strategySaveConfirm({
          newName: $scope.newName
        });
        $scope.newName = '';
      };
      $scope.cancelClicked = function () {
        $scope.newName = '';
      };
    }
  };
};
StrategyEditConfirmDirective.$inject = [];
module.exports = StrategyEditConfirmDirective;